import { EChargeType } from 'interfaces/IEditProduct';
import * as React from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import MyModal from 'v2/components/Shared/MyModal';
import { Space } from 'v2/components/Shared/Space';

import { Breadcrumb } from './Breadcrumb';
import { Form } from './Form';
import { Header } from './Header';
import { useStyles } from './styles';

import type IProduct from 'interfaces/IProduct';

type LocationState = {
  product?: IProduct;
};

type Params = {
  productId: string;
};

function CreateProductOffer() {
  const location = useLocation<LocationState>();
  const params = useParams<Params>();
  const history = useHistory();
  const classes = useStyles();
  const product = location.state?.product;
  const allowTMBPayment = product.beta.includes('product_payment_tmb');

  const [modalOpened, setModalOpened] = React.useState(allowTMBPayment);

  React.useEffect(() => {
    if (!product) {
      history.replace('/producer/product/editproduct/' + params.productId + '/sales');
    }
  }, [product, history, params]);

  const chargeType = React.useMemo(() => {
    if (product?.charge_type === EChargeType.SINGLE) return 'Única';
    return 'Assinatura/Recorrência';
  }, [product]);

  const handleModalSubmit = () => {
    setModalOpened(false);
  };

  return (
    <div>
      <Breadcrumb product={product} />
      <Space size={20} axis='vertical' />
      <Header />
      <Space size={20} axis='vertical' />
      <div className={classes.chargeTypeContainer}>
        <strong>Tipo de cobrança:</strong> {chargeType}
      </div>
      <Space size={24} axis='vertical' />
      <Form productId={Number(params.productId)} />
      <MyModal showCancelButton={false} buttonOk='OK' opened={modalOpened} onSubmit={handleModalSubmit} onClose={() => {}} title={'Atenção'}>
        <p>
          Se este produto possui o parcelamento via TMB ativo, alterações no produto podem afetar o valor exibido no Checkout da TMB ou até remover
          essa forma de pagamento no Checkout da Eduzz. <br />
          Para garantir o funcionamento correto, comunique seu consultor técnico responsável sempre que fizer qualquer alteração neste produto.
        </p>
      </MyModal>
    </div>
  );
}

export { CreateProductOffer };
